import type { SavedJobCv } from '#shared/types/User'

export const MAX_SAVED_CV_BYTES = 10 * 1024 * 1024

export function isSavedJobCv(value: unknown, userId: string): value is SavedJobCv {
    if (!value || typeof value !== 'object' || !userId) return false
    const cv = value as SavedJobCv
    const prefix = `talentbase/${userId}/saved-job-cv/`
    return (
        typeof cv.path === 'string' &&
        cv.path.startsWith(prefix) &&
        /^[\da-f-]{36}\.pdf$/i.test(cv.path.slice(prefix.length)) &&
        typeof cv.name === 'string' &&
        cv.name.length > 0 &&
        cv.name.length <= 255 &&
        Number.isFinite(cv.size) &&
        cv.size > 0 &&
        cv.size <= MAX_SAVED_CV_BYTES &&
        typeof cv.savedAt === 'string'
    )
}

export function isReusableCvFile(file: { type: string; name: string; size: number }): boolean {
    return (
        (file.type === 'application/pdf' || (!file.type && /\.pdf$/i.test(file.name))) &&
        file.size > 0 &&
        file.size <= MAX_SAVED_CV_BYTES
    )
}
